export default "__VITE_ASSET__iH4JeUI___"